module.exports = __webpack_public_path__ + "img/40.2e57d3f6.png";